import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/vehicle/category/brand/models',
        items: [],
    },
    actions: {
		load (context, param) {
			return axios.get(`/vehicle/category/${param.category.id}/brand/${param.brand.id}/models`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}